import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { useLabels } from 'wsm-common-data';

const LoadMoreButton = ({ onClick, showMoreBtn }) => {
	const labels = useLabels();
	let button;

	if (showMoreBtn) {
		button = (
			<Button
				className="d-block w-100 load-more"
				onClick={() => onClick()}
				bsStyle="primary"
				bsSize="lg"
			>
				{labels.get('LOAD_MORE')}
				<i className="ddc-icon ddc-icon-arrow1-down text-light pl-3" />
			</Button>
		);
	} else {
		button = null;
	}

	return button;
};

LoadMoreButton.propTypes = {
	onClick: PropTypes.func.isRequired,
	showMoreBtn: PropTypes.bool.isRequired
};

export default LoadMoreButton;
